import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Module Description', 'modDesc', true, 'asc', 'left'),
  new TableColumn('Is Base', 'isBase', true, 'asc', 'centered')
]

export { Columns }

